function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoCd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBBBA0"
    },
    d: "M256.001,175.938c-44.217,0-80.063,35.844-80.063,80.063c0,44.217,35.845,80.063,80.063,80.063 s80.063-35.845,80.063-80.063C336.064,211.782,300.217,175.938,256.001,175.938z M256.001,296.031 c-22.109,0-40.031-17.922-40.031-40.031s17.923-40.031,40.031-40.031c22.108,0,40.031,17.922,40.031,40.031 S278.11,296.031,256.001,296.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5C9B3"
    },
    d: "M215.969,256c0-22.109,17.923-40.031,40.031-40.031v-40.032c-44.217,0-80.063,35.844-80.063,80.063 c0,44.217,35.845,80.063,80.063,80.063v-40.032C233.892,296.031,215.969,278.11,215.969,256z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256.006,
    cy: 255.996,
    r: 40.031
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5EBAE7"
    },
    d: "M256.001,7.806C118.926,7.806,7.805,118.925,7.805,256c0,137.074,111.12,248.194,248.194,248.194 S504.194,393.074,504.194,256C504.195,118.925,393.074,7.806,256.001,7.806z M256.001,336.063 c-44.217,0-80.063-35.845-80.063-80.063s35.845-80.063,80.063-80.063s80.063,35.844,80.063,80.063 C336.064,300.218,300.217,336.063,256.001,336.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A9E1"
    },
    d: "M256.001,7.806v168.132c44.217,0,80.063,35.844,80.063,80.063c0,44.217-35.845,80.063-80.063,80.063 v168.132c137.074,0,248.194-111.12,248.194-248.194C504.195,118.925,393.074,7.806,256.001,7.806z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M256.001,512.001c-68.38,0-132.667-26.629-181.02-74.98C26.629,388.667,0,324.38,0,256 S26.629,123.334,74.98,74.981c48.353-48.352,112.64-74.98,181.02-74.98s132.667,26.629,181.02,74.98 c48.352,48.353,74.98,112.639,74.98,181.02s-26.629,132.667-74.98,181.02C388.668,485.372,324.381,512.001,256.001,512.001z  M256.001,15.611c-64.21,0-124.578,25.004-169.981,70.409C40.616,131.423,15.611,191.79,15.611,256s25.005,124.577,70.409,169.98 c45.403,45.404,105.771,70.409,169.981,70.409s124.578-25.004,169.981-70.409C471.385,380.577,496.39,320.21,496.39,256 s-25.004-124.577-70.409-169.98C380.577,40.616,320.211,15.611,256.001,15.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M256.001,343.869c-48.451,0-87.869-39.417-87.869-87.869s39.417-87.869,87.869-87.869 s87.869,39.417,87.869,87.869S304.451,343.869,256.001,343.869z M256.001,183.743c-39.843,0-72.258,32.414-72.258,72.258 s32.414,72.258,72.258,72.258s72.258-32.414,72.258-72.258S295.843,183.743,256.001,183.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1B"
    },
    d: "M256.001,303.837c-26.377,0-47.837-21.46-47.837-47.837s21.46-47.837,47.837-47.837 s47.837,21.46,47.837,47.837S282.377,303.837,256.001,303.837z M256.001,223.775c-17.769,0-32.226,14.457-32.226,32.226 s14.457,32.226,32.226,32.226s32.226-14.457,32.226-32.226S273.77,223.775,256.001,223.775z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M471.969,256h-15.611c0-110.477-89.88-200.359-200.359-200.359V40.031 C375.087,40.032,471.969,136.915,471.969,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M186.648,67.968l-5.403-14.645c13.412-4.949,27.387-8.565,41.54-10.751L225.167,58 C212.043,60.026,199.083,63.379,186.648,67.968z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoCd);
export default __webpack_public_path__ + "static/media/disco-cd.f4943dc616e4a4f9ddba5e03a6f0d183.svg";
export { ForwardRef as ReactComponent };